module.exports = __webpack_public_path__ + "static/img/szafa_27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_27.svg
// module id = GT7+
// module chunks = 0